// Curated lucide-react map. A dynamic `import.meta.glob` / index import would
// pull in the whole ~1,500-icon package and defeat tree-shaking; this record
// is the allow-list (D-8). `iconName` is stored kebab-case on the activity type.

import type { LucideIcon } from "lucide-react";
import {
  Activity,
  AirVent,
  AlarmClock,
  Apple,
  Baby,
  Bath,
  BatteryCharging,
  Bed,
  Bike,
  Bird,
  Bone,
  BookOpen,
  Box,
  Brush,
  Bug,
  Building2,
  Bus,
  Cake,
  CalendarDays,
  Camera,
  Car,
  Cat,
  ChefHat,
  Cigarette,
  CircleHelp,
  Citrus,
  ClipboardList,
  Clock,
  CloudSun,
  Coffee,
  CookingPot,
  CreditCard,
  CupSoda,
  Dog,
  Droplet,
  Droplets,
  Dumbbell,
  Egg,
  Fence,
  Fish,
  Flame,
  Flower2,
  Footprints,
  Fuel,
  Gamepad2,
  Gift,
  Glasses,
  Globe,
  Grape,
  Hammer,
  HandHeart,
  Heart,
  House,
  KeyRound,
  Lamp,
  Laptop,
  Leaf,
  Lightbulb,
  Lock,
  Mailbox,
  MapPin,
  Microwave,
  Milk,
  Moon,
  Music,
  Package,
  Paintbrush,
  PawPrint,
  Phone,
  Pill,
  Pizza,
  Plane,
  Plug,
  Recycle,
  Refrigerator,
  Scissors,
  Shirt,
  ShoppingBag,
  ShoppingCart,
  ShowerHead,
  Smartphone,
  Snowflake,
  Sparkles,
  SprayCan,
  Sprout,
  Star,
  Stethoscope,
  StickyNote,
  Sun,
  Syringe,
  Thermometer,
  Trash2,
  Trees,
  Tv,
  Umbrella,
  Utensils,
  Wallet,
  WashingMachine,
  Watch,
  Wheat,
  Wifi,
  Wine,
  Wrench,
  Zap,
} from "lucide-react";

const ICONS: Record<string, LucideIcon> = {
  activity: Activity,
  "air-vent": AirVent,
  "alarm-clock": AlarmClock,
  apple: Apple,
  baby: Baby,
  bath: Bath,
  "battery-charging": BatteryCharging,
  bed: Bed,
  bike: Bike,
  bird: Bird,
  bone: Bone,
  "book-open": BookOpen,
  box: Box,
  brush: Brush,
  bug: Bug,
  "building-2": Building2,
  bus: Bus,
  cake: Cake,
  "calendar-days": CalendarDays,
  camera: Camera,
  car: Car,
  cat: Cat,
  "chef-hat": ChefHat,
  cigarette: Cigarette,
  citrus: Citrus,
  "clipboard-list": ClipboardList,
  clock: Clock,
  "cloud-sun": CloudSun,
  coffee: Coffee,
  "cooking-pot": CookingPot,
  "credit-card": CreditCard,
  "cup-soda": CupSoda,
  dog: Dog,
  droplet: Droplet,
  droplets: Droplets,
  dumbbell: Dumbbell,
  egg: Egg,
  fence: Fence,
  fish: Fish,
  flame: Flame,
  "flower-2": Flower2,
  footprints: Footprints,
  fuel: Fuel,
  "gamepad-2": Gamepad2,
  gift: Gift,
  glasses: Glasses,
  globe: Globe,
  grape: Grape,
  hammer: Hammer,
  "hand-heart": HandHeart,
  heart: Heart,
  house: House,
  "key-round": KeyRound,
  lamp: Lamp,
  laptop: Laptop,
  leaf: Leaf,
  lightbulb: Lightbulb,
  lock: Lock,
  mailbox: Mailbox,
  "map-pin": MapPin,
  microwave: Microwave,
  milk: Milk,
  moon: Moon,
  music: Music,
  package: Package,
  paintbrush: Paintbrush,
  "paw-print": PawPrint,
  phone: Phone,
  pill: Pill,
  pizza: Pizza,
  plane: Plane,
  plug: Plug,
  recycle: Recycle,
  refrigerator: Refrigerator,
  scissors: Scissors,
  shirt: Shirt,
  "shopping-bag": ShoppingBag,
  "shopping-cart": ShoppingCart,
  "shower-head": ShowerHead,
  smartphone: Smartphone,
  snowflake: Snowflake,
  sparkles: Sparkles,
  "spray-can": SprayCan,
  sprout: Sprout,
  star: Star,
  stethoscope: Stethoscope,
  "sticky-note": StickyNote,
  sun: Sun,
  syringe: Syringe,
  thermometer: Thermometer,
  "trash-2": Trash2,
  trees: Trees,
  tv: Tv,
  umbrella: Umbrella,
  utensils: Utensils,
  wallet: Wallet,
  "washing-machine": WashingMachine,
  watch: Watch,
  wheat: Wheat,
  wifi: Wifi,
  wine: Wine,
  wrench: Wrench,
  zap: Zap,
};

export const CURATED_ICON_NAMES = Object.keys(ICONS);

export function ActivityIcon({
  name,
  size = 28,
  className,
}: {
  name: string;
  size?: number;
  className?: string;
}) {
  const Cmp = ICONS[name] ?? CircleHelp;
  return <Cmp size={size} className={className} aria-hidden="true" />;
}
